(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cs-mobile-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll('[data-view-meals]')
    .forEach(function (wrapper) {
      const toggle = wrapper.querySelector(
        '[data-view-meals-toggle]'
      );

      const content = wrapper.querySelector(
        '[data-view-meals-content]'
      );

      if (!toggle || !content) return;

      toggle.addEventListener('click', function () {
        const isOpen =
          toggle.getAttribute('aria-expanded') === 'true';

        toggle.setAttribute(
          'aria-expanded',
          isOpen ? 'false' : 'true'
        );

        content.hidden = isOpen;

        wrapper.classList.toggle(
          'is-open',
          !isOpen
        );
      });
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cs-mobile-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll('[data-cs-mobile-nav-wrapper]')
    .forEach(function (wrapper) {

      const openButtons = wrapper.querySelectorAll(
        '[data-cs-mobile-nav-open]'
      );

      const panels = wrapper.querySelectorAll(
        '[data-cs-mobile-nav-panel]'
      );

      const backButtons = wrapper.querySelectorAll(
        '[data-cs-mobile-nav-back]'
      );


      function closePanels() {
        panels.forEach(function (panel) {
          panel.classList.remove('is-active');
          panel.setAttribute('aria-hidden', 'true');
        });

        openButtons.forEach(function (button) {
          button.setAttribute(
            'aria-expanded',
            'false'
          );
        });

        wrapper.classList.remove(
          'cs-mobile-nav-wrapper--submenu-open'
        );
      }


      openButtons.forEach(function (button) {

        button.addEventListener('click', function () {

          const panelId =
            button.getAttribute(
              'data-cs-mobile-nav-open'
            );

          const panel = wrapper.querySelector(
            '[data-cs-mobile-nav-panel="' +
            panelId +
            '"]'
          );

          if (!panel) return;

          closePanels();

          button.setAttribute(
            'aria-expanded',
            'true'
          );

          panel.classList.add(
            'is-active'
          );

          panel.setAttribute(
            'aria-hidden',
            'false'
          );

          wrapper.classList.add(
            'cs-mobile-nav-wrapper--submenu-open'
          );

          panel.scrollTop = 0;

        });

      });


      backButtons.forEach(function (button) {

        button.addEventListener('click', function () {
          closePanels();
        });

      });

    });
});
  } catch(e) { console.error(e); }
})();

})();
